import React from "react";
import _ from "lodash";

import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";

import TextAreaEditorControl from "components/common/TextAreaEditorControl";
import { MESSAGE } from "constants/Message";
import { JSON_FORMAT_MSG } from "helpers/JsonCheck";

class CustomUPRJsonEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      msg: [],
    };

    this.editorRef = React.createRef();

    this.handleMsgSet = this.handleMsgSet.bind(this);
    this.handleSyncErrMsg = this.handleSyncErrMsg.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleMsgSet(msgType) {
    this.setState({ msg: [JSON_FORMAT_MSG[msgType], msgType] });
  }

  handleSyncErrMsg({ result }) {
    if (result) {
      this.handleMsgSet(MESSAGE.SUCCESS);
    } else {
      this.handleMsgSet(MESSAGE.ERROR);
    }
  }

  handleConfirm() {
    const { handleConfirm } = this.props;

    if (_.isNil(handleConfirm)) {
      return;
    }

    if (_.isNil(this.editorRef.current)) {
      return;
    }

    const data = this.editorRef.current.getData();
    handleConfirm(data);
  }

  render() {
    const { handleCloseModal, currentRule, formErrMsg, formWarnMsg } =
      this.props;
    const { msg } = this.state;

    let parsedMsg = msg;
    if (msg.length === 0 || _.get(msg, 1, null) === MESSAGE.SUCCESS) {
      if (!_.isNil(formErrMsg)) {
        parsedMsg = [formErrMsg, MESSAGE.ERROR];
      } else if (!_.isNil(formWarnMsg)) {
        parsedMsg = [formWarnMsg, MESSAGE.WARNING];
      }
    }

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        handleClose={handleCloseModal}
        title={{
          label: "Edit Rule ",
          highlight: `${currentRule.id} - ${currentRule.name}`,
        }}
        width="50%"
      >
        <div className="mb-4">
          <TextAreaEditorControl
            ref={this.editorRef}
            data={currentRule}
            handleSyncErrMsg={this.handleSyncErrMsg}
          ></TextAreaEditorControl>
        </div>

        <ModalFooter
          msg={parsedMsg}
          switchToCloseOnSuccess={false}
          confirmText="Save"
          onCancel={handleCloseModal}
          onConfirm={this.handleConfirm}
        />
      </ModalWrapper>
    );
  }
}

export default CustomUPRJsonEditModal;
